export default __webpack_public_path__ + "static/media/img2.443b0426.jpg";